export const textEffectsList = [
    { effectType: 'fontWeight', styleName: "fontWeight", isDynamic: false, isStyleActive: false, src: 'note/bold.svg' },
    { effectType: 'italic', styleName: "fontStyle", isDynamic: false, isStyleActive: false, src: 'note/italic.svg' },
    { effectType: 'underline', styleName: "textDecoration", isDynamic: false, isStyleActive: false, src: 'note/underline.svg' },
    { effectType: 'colorpicker', styleName: "color", isDynamic: true, isStyleActive: false, src: 'text/colorpicker.png' },
    { effectType: 'paintbrush', styleName: "backgroundColor", isDynamic: true, isStyleActive: false, src: 'note/paintbrush.pointed.svg' },
]
export const existingStyles = ["fontWeight", "fontStyle", "textDecoration", "color", "backgroundColor"];



const textEffectsClassNames = {
    bold: "boldText",
    italic: "italicText",
    underline: "underlinedText"
};
const textEffectsStyles = {
    fontWeight: {
        styleProperty: "bold",
        stylePropertyName: "fontWeight"
    },
    italic: {
        styleProperty: "italic",
        stylePropertyName: "fontStyle",
    },
    underline: {
        styleProperty: "underline",
        stylePropertyName: "textDecoration",
    },
    colorpicker: {
        styleProperty: "colorpicker",
        stylePropertyName: "color",
    },
    paintbrush: {
        styleProperty: "paintbrush",
        stylePropertyName: "backgroundColor",
    },
    // fontSize: {
    //     styleProperty: "fontSize",
    //     stylePropertyName: "fontSize",
    // }
}

export const insertTextInEditor = (text, id) => {

    // console.log("insertTextInEditor", id)
    const noteBookSheetRef = document.getElementById(id);

    if (noteBookSheetRef) {
        noteBookSheetRef.focus()
        let selection = window.getSelection();
        let range = selection.getRangeAt(0);
        range.deleteContents();
        let node = document.createTextNode(text);
        range.insertNode(node);

        // for (let position = 0; position != text.length; position++) {
        selection.modify("move", "right", "character");
    }

}

export const changeSelectedTextEffects = (params = {}, id, updateTextEffectsStyleStatus) => {
    const { effectType, value: effectValue } = params;
    // console.log(params);
    // console.log(id);

    console.log("changeSelectedTextEffects")

    const noteBookSheetRef = document.getElementById(id);
    const { styleProperty, stylePropertyName } = textEffectsStyles[effectType] ?? { styleProperty: effectValue, stylePropertyName: effectType };

    const styleObject = { [stylePropertyName]: effectValue ? effectValue : styleProperty };
    // console.log("styleProperty:",styleProperty)
    // console.log("stylePropertyName:",stylePropertyName)
    // console.log(styleObject)
    const parentElement = noteBookSheetRef;
    let anchorNode;
    let focusNode;
    const emptySpace = "\u200B";
    if (window.getSelection) {
        const selection = window.getSelection();
        const range = selection?.getRangeAt(0);
        const selectedText = range?.toString();
        const selectedSpans = findRangeSelectedSpans(range, noteBookSheetRef)

        // console.log("selectedText",selectedText)
        if (selection.isCollapsed) {
            console.log("TP1")
            const newSpan = document.createElement('span');
            newSpan.innerHTML = emptySpace;
            const newRange = document.createRange();

            if (selectedSpans.length) {
                const singleSpan = selectedSpans[0];
                const singleSpanStyles = { ...getStyleObject(singleSpan.style) }
                Object.assign(newSpan.style, singleSpanStyles)
                const cursorOffset = range.startOffset
                const spanText = singleSpan.textContent;
                const indexOfCursor = Array.from(spanText).slice(0, cursorOffset).join('').length;
                const textBeforeCursor = spanText.substring(0, indexOfCursor);
                const textAfterCursor = spanText.substring(indexOfCursor);
                if (singleSpan.style[stylePropertyName]) {
                    console.log("HAS")
                    newSpan.style[stylePropertyName] = effectValue;
                } else {
                    console.log("NOT HAVE")
                    newSpan.style[stylePropertyName] = Object.assign(newSpan.style, styleObject);
                }
                const beforeCusorSpan = createSpanWithStyle(
                    singleSpanStyles,
                    textBeforeCursor
                )
                const afterCursorSpan = createSpanWithStyle(
                    singleSpanStyles,
                    textAfterCursor
                )
                if (textBeforeCursor && textAfterCursor) {
                    singleSpan.replaceWith(
                        beforeCusorSpan,
                        newSpan,
                        afterCursorSpan
                    );
                }
                else if (!textBeforeCursor && textAfterCursor) {
                    singleSpan.replaceWith(
                        newSpan,
                        afterCursorSpan
                    );
                }
                else if (textBeforeCursor && !textAfterCursor) {
                    singleSpan.replaceWith(
                        beforeCusorSpan,
                        newSpan,
                    );
                }
                newRange.selectNodeContents(newSpan);
                newRange.collapse(false); // To move the caret to the end of the span
                selection.removeAllRanges();
                selection.addRange(newRange);
                const replacedSpans = findRangeSelectedSpans(newRange, noteBookSheetRef);
                const activeStyles = checkActiveStyles(replacedSpans.at(-1));
                updateTextEffectsStyleStatus(activeStyles);
                return;
            }
            const cursorOffset = range.startOffset
            const divText = noteBookSheetRef.textContent;
            const indexOfCursor = Array.from(divText).slice(0, cursorOffset).join('').length;
            const textBeforeCursor = divText.substring(0, indexOfCursor);
            const textAfterCursor = divText.substring(indexOfCursor);
            parentElement.textContent = "";
            parentElement.innerHTML = "";
            newSpan.style[stylePropertyName] = Object.assign(newSpan.style, styleObject);
            if (textBeforeCursor.length > 0) {
                const textBeforeCursorSpan = createSpanWithStyle(
                    null,
                    textBeforeCursor
                );
                parentElement.appendChild(textBeforeCursorSpan);
            }
            parentElement.appendChild(newSpan);
            if (textAfterCursor.length > 0) {
                const textAfterCursorSpan = createSpanWithStyle(
                    null,
                    textAfterCursor
                );
                parentElement.appendChild(textAfterCursorSpan);
            }
            newRange.selectNodeContents(newSpan);
            newRange.collapse(false); // To move the caret to the end of the span
            selection.removeAllRanges();
            selection.addRange(newRange);
            // noteBookSheetRef.focus();
            const replacedSpans = findRangeSelectedSpans(newRange, noteBookSheetRef);
            const activeStyles = checkActiveStyles(replacedSpans.at(-1));
            updateTextEffectsStyleStatus(activeStyles);
            return;
        }
        if (!selectedSpans.length) {

            console.log("**")

            // console.log(selection.selectNode())

            const startOffset = range.startOffset;
            const endOffset = range.endOffset;
            const allText = parentElement.textContent;

            // console.log("allText", allText)
            // console.log("selectedText", selectedText)

            const splittedText = allText.split(selectedText);
            const beforeText = splittedText[0];
            const afterText = splittedText[1];


            // console.log("beforeText", beforeText)
            // console.log("afterText", afterText)
            // console.log("splittedText", splittedText)

            const isTheSameText = selectedText === beforeText + afterText;
            // parentElement.textContent = "";
            // parentElement.innerHTML = "";
            const middleTextSpan = createSpanWithStyle(
                styleObject,
                selectedText
            );
            // let beforeTextSpan;
            // if (beforeText.length > 0) {
            //     beforeTextSpan = createSpanWithStyle(
            //         null,
            //         beforeText
            //     );
            //     parentElement.appendChild(beforeTextSpan);
            // }
            // parentElement.appendChild(middleTextSpan);
            // let afterTextSpan;
            // if (afterText.length > 0) {
            //     afterTextSpan = createSpanWithStyle(
            //         null,
            //         afterText
            //     );
            //     parentElement.appendChild(afterTextSpan);
            //     return selection.setBaseAndExtent(middleTextSpan, 0, afterTextSpan, 0);

            // }
            // anchorNode = middleTextSpan;
            // focusNode = afterTextSpan || middleTextSpan;
            // selection.setBaseAndExtent(anchorNode, 0, focusNode, afterTextSpan ? 0 : middleTextSpan.childNodes.length);
            console.log(middleTextSpan)
            range.deleteContents();
            // let fragment
            // let child

            // console.log(allText)
            // console.log(range.createContextualFragment)
            // console.log(range)

            // if (range.createContextualFragment) {
            //     fragment = range.createContextualFragment(selectedText);
            // } else {
            //     fragment = document.createDocumentFragment();
            //     while ((child = middleTextSpan.firstChild)) {
            //         fragment.appendChild(child);
            //     }
            // }

            // console.log(fragment)
            // selection.replaceWith(middleTextSpan)

            // console.log(range.cloneContents().querySelectorAll('*'))

            // let firstInsertedNode = middleTextSpan.firstChild;
            // let lastInsertedNode = middleTextSpan.lastChild;

            // console.log(selectedText)
            // console.log(firstInsertedNode)

            // console.log(lastInsertedNode)

            // const br = document.createElement("br");

            // middleTextSpan.appendChild(br)
            range.insertNode(middleTextSpan);
            // range.setStartBefore(firstInsertedNode);
            // range.setEndAfter(lastInsertedNode);

            // range.insertNode(br);

            const activeStyles = checkActiveStyles(focusNode);
            updateTextEffectsStyleStatus(activeStyles);
            return;
        } else if (selectedSpans.length === 1) {
            console.log("ONE SPAN");
            const singleSpan = selectedSpans[0];



            const containsStyleProperty = singleSpan.style[stylePropertyName];


            // console.log(singleSpan)
            // console.log(containsStyleProperty)

            // return

            if (selectedText.length !== selectedSpans[0].textContent.length) {
                // console.log("not equal block")
                const splittedText = singleSpan.textContent.length > selectedText.length ? singleSpan.textContent.split(selectedText) : selectedText.split(singleSpan.textContent);
                // console.log(splittedText);
                // console.log(singleSpan);

                const beforeTextSpan = createSpanWithStyle({ ...getStyleObject(singleSpan.style) }, splittedText[0]);

                const middleTextSpan = createSpanWithStyle({ ...getStyleObject(singleSpan.style) }, selectedText);

                containsStyleProperty ? middleTextSpan.style[stylePropertyName] = effectValue : Object.assign(middleTextSpan.style, styleObject);

                const afterTextSpan = createSpanWithStyle({ ...getStyleObject(singleSpan.style) }, splittedText[1]);



                if (containsStyleProperty) {
                    Object.assign(beforeTextSpan.style, styleObject);
                    Object.assign(afterTextSpan.style, styleObject);
                } else {
                    // console.log(beforeTextSpan.style)
                    // console.log(beforeTextSpan.style[stylePropertyName])
                    if (beforeTextSpan.style[stylePropertyName]) {
                        beforeTextSpan.style[stylePropertyName] = effectValue;
                    }
                    if (afterTextSpan.style[stylePropertyName]) {
                        afterTextSpan.style[stylePropertyName] = effectValue
                    }
                }
                if (splittedText[0] && splittedText[1]) {
                    singleSpan.replaceWith(
                        beforeTextSpan,
                        middleTextSpan,
                        afterTextSpan
                    );
                    anchorNode = middleTextSpan;
                    focusNode = afterTextSpan;
                } else if (
                    splittedText[0] &&
                    !splittedText[1]
                ) {
                    singleSpan.replaceWith(
                        beforeTextSpan,
                        middleTextSpan
                    );
                    anchorNode = middleTextSpan;
                    focusNode = middleTextSpan;
                } else if (
                    !splittedText[0] &&
                    splittedText[1]
                ) {
                    singleSpan.replaceWith(
                        middleTextSpan,
                        afterTextSpan
                    );
                    anchorNode = middleTextSpan;
                    focusNode = afterTextSpan;
                } else {
                    singleSpan.replaceWith(middleTextSpan);
                    anchorNode = middleTextSpan;
                    focusNode = middleTextSpan;
                }
            } else {
                containsStyleProperty ? singleSpan.style[stylePropertyName] = effectValue : Object.assign(singleSpan.style, styleObject);

                const activeStyles = checkActiveStyles(singleSpan);
                updateTextEffectsStyleStatus(activeStyles);
                // selection.setBaseAndExtent(anchorNode, 0, focusNode, 0);
            }
            console.log("setBaseAndExtent 3");
            if (anchorNode && focusNode) {
                console.log(anchorNode, focusNode)
                const activeStyles = checkActiveStyles(focusNode);
                updateTextEffectsStyleStatus(activeStyles);
                if (anchorNode !== focusNode) {
                    selection.setBaseAndExtent(anchorNode, 0, focusNode, 0);
                } else {
                    selection.setBaseAndExtent(anchorNode, 0, focusNode, 1);
                }
            }
            // else{

            // }

        } else {
            console.log("MULTIPLE SPANS")
            const everyContainsStyleProperty = selectedSpans.every((span) =>
                span.style[stylePropertyName] !== effectValue
            );
            const someContainsStyleProperty = selectedSpans.some((span) =>
                span.style[stylePropertyName] !== effectValue
            );
            const spansWithTheEffect = selectedSpans.filter((span) =>
                span.style[stylePropertyName] !== effectValue
            );
            console.log(everyContainsStyleProperty)
            const spansFullText = selectedSpans
                .map((span) => span.textContent)
                .join("");
            const splittedFullText = spansFullText.split(selectedText);
            console.log(selectedSpans)
            selectedSpans.forEach((selectedSpan, spanIndex) => {
                console.log(selectedSpan.style[stylePropertyName], spanIndex);
                console.log(selectedSpan.innerHTML)
                const spanHasBreak = selectedSpan.innerHTML.includes('<br>');
                console.log(spanHasBreak);
                const brElement = document.createElement("br");
                let partsSum = 0;
                if (spanIndex === 0) {
                    console.log("INSIDE INDEX 0", selectedSpan)
                    const firstPart = createSpanWithStyle(
                        { ...getStyleObject(selectedSpan.style) },
                        splittedFullText[0]
                    );

                    const indexDifference =
                        selectedSpan.textContent.length -
                        splittedFullText[0].length;
                    const secondPartTextContent =
                        selectedText.substring(0, indexDifference);
                    const secondPart = createSpanWithStyle(
                        { ...getStyleObject(selectedSpan.style) },
                        secondPartTextContent
                    );
                    if (everyContainsStyleProperty) {
                        secondPart.style[stylePropertyName] = effectValue
                    } else {
                        if (spansWithTheEffect.length == 1 && !everyContainsStyleProperty) {
                            if (spansWithTheEffect[0] === selectedSpan) {
                                if (secondPart.style[stylePropertyName]) {
                                    secondPart.style[stylePropertyName] = effectValue;
                                } else {
                                    Object.assign(secondPart.style, styleObject)
                                }
                            }
                        }

                        else if (spansWithTheEffect.length > 1 && !everyContainsStyleProperty) {
                            Object.assign(secondPart.style, styleObject);
                        }
                        else if (everyContainsStyleProperty) {
                            secondPart.style[stylePropertyName] = effectValue;
                        }
                        else {
                            if (secondPart.style[stylePropertyName]) {
                                secondPart.style[stylePropertyName] = effectValue;
                            } else {
                                Object.assign(secondPart.style, styleObject);
                            }
                        }
                    }
                    anchorNode = secondPart;
                    if (spanHasBreak) {

                        if (splittedFullText[0] && secondPartTextContent) {
                            selectedSpan.replaceWith(brElement, firstPart, secondPart);
                        }
                        else if (splittedFullText[0] && !secondPartTextContent) {
                            selectedSpan.replaceWith(brElement, firstPart);
                        }
                        else if (!splittedFullText[0] && secondPartTextContent) {
                            selectedSpan.replaceWith(brElement, secondPart);
                        }
                        else {
                            if (selectedSpan.style[stylePropertyName]) {
                                selectedSpan.style[stylePropertyName] = effectValue;
                            } else {
                                Object.assign(selectedSpan.style, styleObject)
                            }
                        }
                    }
                    else {
                        if (splittedFullText[0] && secondPartTextContent) {
                            selectedSpan.replaceWith(firstPart, secondPart);
                        }
                        else if (splittedFullText[0] && !secondPartTextContent) {
                            selectedSpan.replaceWith(firstPart);
                        }
                        else if (!splittedFullText[0] && secondPartTextContent) {
                            selectedSpan.replaceWith(secondPart);
                        }
                        else {
                            if (selectedSpan.style[stylePropertyName]) {
                                selectedSpan.style[stylePropertyName] = effectValue;
                            } else {
                                Object.assign(selectedSpan.style, styleObject)
                            }
                        }
                    }
                } else if (spanIndex === selectedSpans.length - 1) {
                    console.log("INSIDE LAST INDEX", selectedSpan)
                    const secondPart = createSpanWithStyle(
                        { ...getStyleObject(selectedSpan.style) },
                        splittedFullText.at(-1)
                    );
                    const indexDifference =
                        selectedSpan.textContent.length -
                        splittedFullText.at(-1).length;
                    const firstPartTextContent = selectedText.substring(
                        selectedText.length - indexDifference
                    );

                    const firstPart = createSpanWithStyle(
                        { ...getStyleObject(selectedSpan.style) },
                        firstPartTextContent
                    );
                    if (spansWithTheEffect.length == 1 && !everyContainsStyleProperty) {
                        if (spansWithTheEffect[0] === selectedSpan) {
                            if (firstPart.style[stylePropertyName]) {
                                firstPart.style[stylePropertyName] = effectValue;
                            } else {
                                Object.assign(firstPart.style, styleObject)
                            }
                        }
                    }
                    else if (spansWithTheEffect.length > 1 && !everyContainsStyleProperty) {
                        Object.assign(firstPart.style, styleObject);
                    }
                    else if (everyContainsStyleProperty) {
                        firstPart.style[stylePropertyName] = effectValue;
                    }
                    else {
                        if (firstPart.style[stylePropertyName]) {
                            firstPart.style[stylePropertyName] = effectValue;
                        } else {
                            Object.assign(firstPart.style, styleObject)
                        }
                    }
                    if (spanHasBreak) {

                        if (firstPart.textContent && secondPart.textContent) {
                            selectedSpan.replaceWith(brElement, firstPart, secondPart);
                            focusNode = firstPart;
                            console.log("trim 1", secondPart)
                        }
                        else if (firstPart.textContent && !secondPart.textContent) {
                            selectedSpan.replaceWith(brElement, firstPart);
                            console.log("trim 2", firstPart);
                            focusNode = firstPart;
                        }
                        else if (!firstPart.textContent && secondPart.textContent) {
                            selectedSpan.replaceWith(brElement, secondPart);
                            console.log("trim 3", firstPart)
                            focusNode = firstPart;
                        }
                        else {
                            if (selectedSpan.style[stylePropertyName]) {
                                selectedSpan.style[stylePropertyName] = effectValue;
                            } else {
                                Object.assign(selectedSpan.style, styleObject)
                            }
                            console.log("trim 4", selectedSpan)
                            focusNode = selectedSpan
                        }
                    } else {
                        if (firstPart.textContent && secondPart.textContent) {
                            selectedSpan.replaceWith(firstPart, secondPart);
                            focusNode = firstPart;
                            console.log("trim 1", secondPart)
                        }
                        else if (firstPart.textContent && !secondPart.textContent) {
                            selectedSpan.replaceWith(firstPart);
                            console.log("trim 2", firstPart);
                            focusNode = firstPart;
                        }
                        else if (!firstPart.textContent && secondPart.textContent) {
                            selectedSpan.replaceWith(secondPart);
                            console.log("trim 3", firstPart)
                            focusNode = firstPart;
                        }
                        else {
                            if (selectedSpan.style[stylePropertyName]) {
                                selectedSpan.style[stylePropertyName] = effectValue;
                            } else {
                                Object.assign(selectedSpan.style, styleObject)
                            }
                            console.log("trim 4", selectedSpan)
                            focusNode = selectedSpan
                        }
                    }
                } else {
                    console.log("INSIDE MIDDLE INDEXES");
                    console.log(selectedSpan);
                    if (spansWithTheEffect.length == 1 && !everyContainsStyleProperty) {
                        if (spansWithTheEffect[0] === selectedSpan) {
                            if (selectedSpan.style[stylePropertyName]) {
                                selectedSpan.style[stylePropertyName] = effectValue;
                            } else {
                                Object.assign(selectedSpan.style, styleObject)
                            }
                        }
                    }
                    else if (spansWithTheEffect.length > 1 && !everyContainsStyleProperty) {
                        Object.assign(selectedSpan.style, styleObject);
                    }
                    else if (everyContainsStyleProperty) {
                        selectedSpan.style[stylePropertyName] = effectValue;
                    }
                    else {
                        if (selectedSpan.style[stylePropertyName]) {
                            selectedSpan.style[stylePropertyName] = effectValue;
                        } else {
                            Object.assign(selectedSpan.style, styleObject)
                        }
                    }
                }
            });
            //working on this part
            const range1 = document.createRange();
            // console.log(anchorNode, focusNode)
            console.log("setBaseAndExtent 4");
            // // setTimeout(() => {
            console.log(anchorNode.nextSibling)
            console.log(focusNode)
            const activeStyles = checkActiveStyles(focusNode);
            updateTextEffectsStyleStatus(activeStyles);
            return selection.setBaseAndExtent(anchorNode, 0, focusNode, 1);
            // }, 100)
        }
    } else if (document.selection) {
        // should come last; Opera!
    }
};



export const createSpanWithStyle = (style, textContent) => {
    try {
        console.log("createSpanWithStyle")
        console.log(style)
        const span = document.createElement("span");
        // if (style) {
        //     Object.assign(span.style, style);
        // }
        // console.log(span.style);
        if (textContent) {
            span.textContent = textContent;
        }
        return span;
    } catch (error) {
        console.log(error);
    }
};

export const findRangeSelectedSpans = (range, element) => {
    const allSpans = Array.from(
        element.getElementsByTagName("span")
    );
    const selectedSpans = allSpans.filter((span) => {
        const spanRange = document.createRange();
        spanRange.selectNode(span);
        return (
            range.intersectsNode(span) &&
            range.compareBoundaryPoints(
                Range.END_TO_START,
                spanRange
            ) !== 1
        );
    });


    return selectedSpans;
}

export const checkActiveStyles = (spanElement) => {
    const activeStyles = [];
    if (!spanElement) return activeStyles;
    const spanStyles = existingStyles.filter(style => spanElement.style[style] !== "");
    return spanStyles;
}

export const getStyleObject = (style) => {
    const styleObject = {};
    for (let i = 0; i < style.length; i++) {
        const property = style[i];
        styleObject[property] = style.getPropertyValue(property);
    }
    return styleObject;
}

// export const createNotebookImage = (src) => {
//     const img = document.createElement("img");
//     img.src = src;
//     img.style.width = "100%";
//     img.style.height = "100%";
//     return img;
// }


export function createNotebookImage(src) {
    return <img width={"100%"} height={"100%"} src={src} />;
}

